import { useNavigate } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge, PriorityBadge, TypeBadge, SlaChip } from "@/components/StatusBadge";
import { useData } from "@/context/DataContext";
import { addressLine, fmtDate, SLOTS } from "@/lib/format";
import { Empty } from "@/components/Common";

export const OrderTable = ({ orders, testId = "orders-table" }) => {
  const navigate = useNavigate();
  const { nameOf } = useData();
  if (!orders.length) return <Empty text="Nessun ordine trovato con i filtri selezionati" testId={`${testId}-empty`} />;
  return (
    <div className="overflow-x-auto border bg-white" data-testid={testId}>
      <Table>
        <TableHeader>
          <TableRow className="bg-muted/50">
            <TableHead>Codice esterno</TableHead>
            <TableHead>Attività</TableHead>
            <TableHead>Committente / Gestore</TableHead>
            <TableHead>Cliente / Località</TableHead>
            <TableHead>Titolare → Esecutrice</TableHead>
            <TableHead>Stato</TableHead>
            <TableHead>Priorità / SLA</TableHead>
            <TableHead>Pianificazione</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {orders.map((o) => (
            <TableRow key={o.id} onClick={() => navigate(`/ordini/${o.id}`)} data-testid={`order-row-${o.external_order_id}`}
              className={`cursor-pointer transition-colors hover:bg-accent/60 border-l-2 ${o.service_type === "ASSURANCE" ? "border-l-urgent" : "border-l-primary"}`}>
              <TableCell>
                <div className="font-mono text-sm font-semibold">{o.external_order_id}</div>
                <div className="font-mono text-[11px] text-muted-foreground">{nameOf("projects", o.project_id, "code")}</div>
              </TableCell>
              <TableCell><TypeBadge type={o.service_type} /><div className="mt-0.5 text-xs text-muted-foreground">{o.technology}</div></TableCell>
              <TableCell>
                <div className="text-sm font-medium">{nameOf("parties", o.customer_id)}</div>
                <div className="text-xs text-muted-foreground">{nameOf("parties", o.infrastructure_manager_id)}</div>
              </TableCell>
              <TableCell>
                <div className="text-sm">{o.customer_name || "—"}</div>
                <div className="text-xs text-muted-foreground">{addressLine(o.address)}</div>
              </TableCell>
              <TableCell className="text-sm">
                <div>{nameOf("companies", o.contract_company_id, "code")}</div>
                {o.executing_company_id !== o.contract_company_id && <div className="text-xs font-semibold text-urgent">→ {nameOf("companies", o.executing_company_id, "code")}</div>}
              </TableCell>
              <TableCell><StatusBadge status={o.status} />{o.rework_count > 0 && <div className="mt-1 text-[11px] text-red-600">Rilavorazioni: {o.rework_count}</div>}</TableCell>
              <TableCell><div className="flex flex-col items-start gap-1"><PriorityBadge priority={o.priority} /><SlaChip order={o} /></div></TableCell>
              <TableCell className="text-sm">
                {o.scheduled_date ? (
                  <><div>{fmtDate(o.scheduled_date)} · {SLOTS[o.slot]}</div><div className="text-xs text-muted-foreground">{nameOf("teams", o.team_id)} · {nameOf("employees", o.employee_id)}</div></>
                ) : <span className="text-muted-foreground">—</span>}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
